module.exports = __webpack_public_path__ + "img/play-button-g.430039e5.svg";